export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img2-339a2f8fc580a0b0e26a1fcb81115fe6.png";